// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27rgba%28255,255,255,0.35%29%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%276 9 12 15 18 9%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * ============================================================
 *  3D Configurator — Premium Dark UI Styles
 *
 *  Every selector is prefixed with .cfg- to prevent leaking
 *  into the host page. No global resets are applied here.
 * ============================================================
 */

/* ── Box-sizing reset scoped to our component ─────────────── */
.cfg-wrapper,
.cfg-wrapper *,
.cfg-wrapper *::before,
.cfg-wrapper *::after {
  box-sizing: border-box;
}

/* ── Root wrapper (flex container) ───────────────────────── */
.cfg-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  min-height: 480px;
  position: relative;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI',
    Helvetica, Arial, sans-serif;
  font-size: 14px;
  color: #e0e0e0;
  background: #0a0c14;
  overflow: hidden;
}

/* ─────────────────────────────────────────────────────────────
   LEFT PANEL — product card navigation
   ───────────────────────────────────────────────────────────── */

.cfg-left-panel {
  width: 340px;
  min-width: 260px;
  flex-shrink: 0;
  background: linear-gradient(180deg, #0d0f1c 0%, #0a0c14 100%);
  border-right: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: column;
  z-index: 2;
  overflow: hidden;
}

/* ── Left panel header ── */
.cfg-left-header {
  padding: 32px 28px 20px;
  flex-shrink: 0;
}

.cfg-left-eyebrow {
  font-size: 0.62rem;
  font-weight: 600;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: rgba(160, 180, 255, 0.55);
  margin: 0 0 10px;
}

.cfg-left-title {
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  margin: 0;
  line-height: 1.25;
  letter-spacing: -0.01em;
}

/* ── Product card list ── */
.cfg-card-list {
  flex: 1;
  padding: 4px 16px 16px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: rgba(255,255,255,0.08) transparent;
}

.cfg-card-list::-webkit-scrollbar {
  width: 4px;
}
.cfg-card-list::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.10);
  border-radius: 2px;
}

/* ── Individual product card ── */
.cfg-card {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 16px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;
  position: relative;
  overflow: hidden;
  width: 100%;
  text-align: left;
  font-family: inherit;
  color: inherit;
}

.cfg-card:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.12);
}

.cfg-card--active {
  background: rgba(100, 130, 255, 0.08);
  border-color: rgba(100, 130, 255, 0.30);
}

.cfg-card--active::before {
  content: '';
  position: absolute;
  inset: 0;
  background: linear-gradient(135deg, rgba(100,130,255,0.06) 0%, transparent 60%);
  pointer-events: none;
}

.cfg-card:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* ── Card thumbnail ── */
.cfg-card__thumb {
  width: 72px;
  height: 60px;
  border-radius: 10px;
  background: linear-gradient(135deg, #1a1e32 0%, #0f1220 100%);
  border: 1px solid rgba(255,255,255,0.07);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  overflow: hidden;
}

.cfg-card__thumb svg {
  width: 36px;
  height: 36px;
  opacity: 0.55;
  color: rgba(160, 180, 255, 0.8);
}

.cfg-card--active .cfg-card__thumb {
  border-color: rgba(100, 130, 255, 0.25);
  background: linear-gradient(135deg, #1e2540 0%, #131828 100%);
}

.cfg-card--active .cfg-card__thumb svg {
  opacity: 0.85;
}

/* ── Card text ── */
.cfg-card__body {
  flex: 1;
  min-width: 0;
}

.cfg-card__name {
  font-size: 0.88rem;
  font-weight: 600;
  color: #e0e4f0;
  margin: 0 0 4px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cfg-card--active .cfg-card__name {
  color: #ffffff;
}

.cfg-card__sub {
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.35);
  margin: 0 0 10px;
  line-height: 1.3;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ── Card indicator dots ── */
.cfg-card__dots {
  display: flex;
  gap: 5px;
}

.cfg-card__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
}

.cfg-card--active .cfg-card__dot:first-child {
  background: rgba(120, 150, 255, 0.75);
}

.cfg-card--active .cfg-card__dot:nth-child(2) {
  background: rgba(120, 150, 255, 0.45);
}

/* ── Left panel footer ── */
.cfg-left-footer {
  padding: 20px 28px 28px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.cfg-left-footer__desc {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.30);
  line-height: 1.5;
  margin: 0 0 16px;
}

.cfg-explore-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 22px;
  background: rgba(100, 130, 255, 0.12);
  border: 1px solid rgba(100, 130, 255, 0.30);
  border-radius: 999px;
  color: rgba(160, 180, 255, 0.9);
  font-size: 0.78rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;
  white-space: nowrap;
  letter-spacing: 0.02em;
}

.cfg-explore-btn:hover {
  background: rgba(100, 130, 255, 0.22);
  border-color: rgba(100, 130, 255, 0.55);
  color: #fff;
}

.cfg-explore-btn svg {
  width: 13px;
  height: 13px;
}

.cfg-left-footer__contact {
  font-size: 0.68rem;
  color: rgba(255, 255, 255, 0.20);
  margin: 12px 0 0;
}

.cfg-left-footer__contact a {
  color: rgba(160, 180, 255, 0.45);
  text-decoration: none;
}

.cfg-left-footer__contact a:hover {
  color: rgba(160, 180, 255, 0.75);
}

/* ─────────────────────────────────────────────────────────────
   CENTRE (canvas area)
   ───────────────────────────────────────────────────────────── */

.cfg-center {
  flex: 1;
  position: relative;
  overflow: hidden;
  background: #0a0c14;
}

.cfg-canvas {
  display: block;
  width: 100%;
  height: 100%;
}

/* ─────────────────────────────────────────────────────────────
   RIGHT PANEL — floating overlay (position: absolute inside center)
   ───────────────────────────────────────────────────────────── */

/* ── Outer wrapper — flyout grows left, panel stays on the right ── */
.cfg-panel-wrap {
  position: absolute;
  top: 20px;
  right: 20px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 8px;
  z-index: 20;
}

/* ── Single panel — collapses to narrow strip, expands in-place ── */
.cfg-right-panel {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 68px;
  overflow: hidden;
  background: rgba(10, 12, 22, 0.82);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50), 0 0 0 1px rgba(255,255,255,0.03) inset;
  transition: width 0.22s cubic-bezier(0.4, 0, 0.2, 1);
}

.cfg-right-panel--expanded {
  width: 242px;
}

/* ── Collapsed view — icon strip ── */
.cfg-strip-view {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 6px 8px;
  gap: 2px;
  width: 100%;
}

/* ── Expanded view — full panel content ── */
.cfg-full-view {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
}

/* ── Flyout (single-section popout, shown while panel is collapsed) ── */
.cfg-flyout {
  display: flex;
  flex-direction: column;
  background: rgba(10, 12, 22, 0.82);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50), 0 0 0 1px rgba(255,255,255,0.03) inset;
  width: 200px;
  overflow: hidden;
  align-self: flex-start;
  transition: margin-top 0.18s cubic-bezier(0.4, 0, 0.2, 1);
}

/* ── Expand / collapse toggle at top of strip ── */
.cfg-panel-toggle-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 52px;
  padding: 8px 4px;
  background: transparent;
  border: none;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.40);
  cursor: pointer;
  transition: color 0.15s, background 0.15s;
  flex-shrink: 0;
  font-family: inherit;
  border-radius: 8px 8px 0 0;
  margin-bottom: 2px;
  width: 100%;
}

.cfg-panel-toggle-btn:hover {
  color: rgba(255, 255, 255, 0.85);
  background: rgba(255, 255, 255, 0.05);
}

.cfg-panel-toggle-btn svg {
  width: 15px;
  height: 15px;
}

/* ── Icon + label buttons in strip ── */
.cfg-strip-btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  padding: 7px 4px;
  background: transparent;
  border: none;
  border-radius: 10px;
  color: rgba(255, 255, 255, 0.42);
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  flex-shrink: 0;
  font-family: inherit;
}

.cfg-strip-btn:hover {
  background: rgba(255, 255, 255, 0.07);
  color: rgba(255, 255, 255, 0.85);
}

.cfg-strip-btn--active {
  background: rgba(100, 130, 255, 0.15);
  color: rgba(160, 180, 255, 0.95);
}

/* Pinned = clicked open, stays until clicked again */
.cfg-strip-btn--pinned {
  background: rgba(100, 130, 255, 0.22);
  color: rgba(180, 200, 255, 1);
  border-radius: 10px;
  box-shadow: inset 0 0 0 1px rgba(120, 150, 255, 0.35);
}

.cfg-strip-btn svg {
  width: 15px;
  height: 15px;
  flex-shrink: 0;
}

.cfg-colour-strip-globe {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1.5px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 1px 4px rgba(0,0,0,0.4);
  transition: background 0.25s ease;
}

.cfg-strip-btn__label {
  font-size: 0.52rem;
  font-weight: 500;
  letter-spacing: 0.03em;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
}

/* ── Divider between section icons and action icons ── */
.cfg-strip-divider {
  width: 70%;
  height: 1px;
  background: rgba(255, 255, 255, 0.07);
  margin: 4px 0;
  flex-shrink: 0;
}

/* ── Legacy .cfg-side-panel (kept for any lingering refs) ── */
.cfg-side-panel {
  display: flex;
  flex-direction: column;
  background: rgba(10, 12, 22, 0.82);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50), 0 0 0 1px rgba(255,255,255,0.03) inset;
  overflow: hidden;
  width: 200px;
}

.cfg-side-panel--expanded {
  width: 242px;
}

/* ── Flyout title ── */
.cfg-flyout-title {
  font-size: 0.60rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.30);
  margin: 0 0 10px;
  padding: 12px 14px 0;
}

/* ── Full panel inner scroll area ── */
.cfg-panel-content-inner {
  padding: 11px 14px 14px;
  display: flex;
  flex-direction: column;
  gap: 11px;
  overflow-y: auto;
  max-height: calc(100vh - 100px);
  scrollbar-width: none;
}

.cfg-panel-content-inner::-webkit-scrollbar {
  display: none;
}

/* Flyout content padding (no title, so pad all sides evenly) */
.cfg-flyout .cfg-color-grid,
.cfg-flyout .cfg-variant-list {
  margin: 12px;
}

/* ── Panel header ── */
.cfg-panel-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 11px 14px 10px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  flex-shrink: 0;
}

.cfg-panel-header__title {
  font-size: 0.82rem;
  font-weight: 700;
  color: #ffffff;
  letter-spacing: 0.02em;
  margin: 0;
}

.cfg-panel-header__dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(100, 200, 120, 0.75);
  box-shadow: 0 0 6px rgba(100, 200, 120, 0.5);
}


/* ── Section labels ── */
.cfg-section-label {
  font-size: 0.60rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.30);
  margin: 0 0 10px;
}

/* ── Colour swatches — 3D globe style ── */
.cfg-color-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.cfg-color-swatch {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: none;
  outline: none;
  padding: 0;
  cursor: pointer;
  position: relative;
  flex-shrink: 0;
  /* depth shadow to sell the sphere illusion */
  box-shadow:
    inset -2px -3px 5px rgba(0, 0, 0, 0.28),
    inset 1px 1px 2px rgba(255, 255, 255, 0.10),
    0 3px 8px rgba(0, 0, 0, 0.40);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.cfg-color-swatch:hover {
  transform: scale(1.18) translateY(-1px);
  box-shadow:
    inset -2px -3px 5px rgba(0, 0, 0, 0.28),
    inset 1px 1px 2px rgba(255, 255, 255, 0.10),
    0 6px 14px rgba(0, 0, 0, 0.50);
}

.cfg-color-swatch--active,
.cfg-color-swatch--active:hover {
  transform: scale(1.18) translateY(-1px);
  box-shadow:
    inset -2px -3px 5px rgba(0, 0, 0, 0.28),
    inset 1px 1px 2px rgba(255, 255, 255, 0.10),
    0 6px 14px rgba(0, 0, 0, 0.50),
    0 0 0 2px rgba(255, 255, 255, 0.75);
}

/* ── Variant buttons (side by side) ── */
.cfg-variant-list {
  display: flex;
  gap: 8px;
}

.cfg-variant-btn {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  padding: 8px 6px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.50);
  font-size: 0.75rem;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  text-align: center;
  transition: background 0.18s, color 0.18s, border-color 0.18s;
}

.cfg-variant-btn__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  opacity: 0.65;
  flex-shrink: 0;
}

.cfg-variant-btn__icon svg {
  width: 100%;
  height: 100%;
}

.cfg-variant-btn__label {
  line-height: 1;
}

.cfg-variant-btn--active .cfg-variant-btn__icon {
  opacity: 1;
}

.cfg-variant-btn:hover {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.80);
}

.cfg-variant-btn--active {
  background: rgba(100, 130, 255, 0.15);
  border-color: rgba(100, 130, 255, 0.40);
  color: rgba(160, 180, 255, 0.95);
}

/* ── AA Select ── */
.cfg-aa-select {
  width: 100%;
  padding: 7px 28px 7px 10px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.09);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.70);
  font-size: 0.78rem;
  font-family: inherit;
  cursor: pointer;
  appearance: none;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 10px center;
  transition: border-color 0.18s, background-color 0.18s;
  outline: none;
}

.cfg-aa-select:hover {
  border-color: rgba(255, 255, 255, 0.18);
  background-color: rgba(255, 255, 255, 0.08);
}

.cfg-aa-select:focus {
  border-color: rgba(100, 130, 255, 0.45);
}

.cfg-aa-select option {
  background: #111420;
  color: #e0e4f0;
}

/* ── Divider ── */
.cfg-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
  margin: 2px 0;
  flex-shrink: 0;
}

/* ── Reset camera button ── */
.cfg-reset-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 7px 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 9px;
  color: rgba(255, 255, 255, 0.60);
  font-size: 0.78rem;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  width: 100%;
  transition: background 0.18s, color 0.18s, border-color 0.18s;
}

.cfg-reset-btn:hover {
  background: rgba(255, 255, 255, 0.10);
  color: rgba(255, 255, 255, 0.90);
  border-color: rgba(255, 255, 255, 0.20);
}

.cfg-reset-btn svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

/* ── Fullscreen button ── */
.cfg-fullscreen-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 7px 12px;
  background: linear-gradient(135deg, rgba(60, 100, 255, 0.55) 0%, rgba(40, 70, 220, 0.55) 100%);
  border: 1px solid rgba(100, 140, 255, 0.35);
  border-radius: 9px;
  color: rgba(200, 215, 255, 0.95);
  font-size: 0.78rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  width: 100%;
  transition: background 0.18s, border-color 0.18s, color 0.18s;
  margin-top: 0;
}

.cfg-fullscreen-btn:hover {
  background: linear-gradient(135deg, rgba(80, 120, 255, 0.70) 0%, rgba(60, 90, 240, 0.70) 100%);
  border-color: rgba(130, 160, 255, 0.55);
  color: #fff;
}

.cfg-fullscreen-btn svg {
  width: 14px;
  height: 14px;
  flex-shrink: 0;
}

/* ── Bottom icon buttons row ── */
.cfg-icon-row {
  display: flex;
  gap: 8px;
  margin-top: 2px;
}

.cfg-icon-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 9px;
  color: rgba(255, 255, 255, 0.45);
  cursor: pointer;
  transition: background 0.18s, color 0.18s, border-color 0.18s;
}

.cfg-icon-btn:hover {
  background: rgba(255, 255, 255, 0.09);
  color: rgba(255, 255, 255, 0.80);
  border-color: rgba(255, 255, 255, 0.16);
}

.cfg-icon-btn svg {
  width: 15px;
  height: 15px;
}

/* ── Panel section separator ── */
.cfg-panel-section {
  display: flex;
  flex-direction: column;
}

/* ── Panel toggle (collapse header) ── */
.cfg-panel-toggle {
  display: none; /* desktop: hidden, mobile uses this */
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.30);
  font-size: 0.60rem;
  font-weight: 700;
  letter-spacing: 0.10em;
  text-transform: uppercase;
  cursor: pointer;
  font-family: inherit;
}

.cfg-panel-toggle-icon {
  font-style: normal;
  font-size: 0.75rem;
  transition: transform 0.2s ease;
}


/* ── Old panel title class (kept for rightPanel.ts compat) ── */
.cfg-panel-title {
  margin: 0 0 8px;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.30);
  padding-bottom: 0;
  border-bottom: none;
}

/* ─────────────────────────────────────────────────────────────
   LOADING OVERLAY
   ───────────────────────────────────────────────────────────── */

.cfg-loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(10, 12, 20, 0.80);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  z-index: 50;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.cfg-spinner {
  width: 36px;
  height: 36px;
  border: 2px solid rgba(255, 255, 255, 0.08);
  border-top-color: rgba(100, 130, 255, 0.80);
  border-radius: 50%;
  animation: cfg-spin 0.75s linear infinite;
}

@keyframes cfg-spin {
  to { transform: rotate(360deg); }
}

.cfg-loading-text {
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.30);
  letter-spacing: 0.06em;
}

/* ─────────────────────────────────────────────────────────────
   VARIANT LOADER  (small floating indicator, not full overlay)
   ───────────────────────────────────────────────────────────── */

.cfg-variant-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -70%);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.28s ease;
  z-index: 10;
}

.cfg-variant-loader--visible {
  opacity: 1;
}

.cfg-variant-loader .cfg-spinner {
  width: 26px;
  height: 26px;
  border-width: 2px;
  border-color: rgba(255,255,255,0.06);
  border-top-color: rgba(140, 160, 255, 0.85);
}

.cfg-variant-loader .cfg-loading-text {
  font-size: 0.68rem;
  color: rgba(255, 255, 255, 0.22);
}

/* ─────────────────────────────────────────────────────────────
   FOCUS RESET BUTTON (viewport overlay)
   ───────────────────────────────────────────────────────────── */

.cfg-focus-reset-btn {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  display: none;
  align-items: center;
  gap: 6px;
  padding: 9px 20px;
  background: rgba(10, 12, 22, 0.72);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(100, 130, 255, 0.40);
  border-radius: 999px;
  color: rgba(160, 180, 255, 0.90);
  font-size: 13px;
  font-family: inherit;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.18s, color 0.18s;
}

.cfg-focus-reset-btn:hover {
  background: rgba(100, 130, 255, 0.25);
  color: #fff;
}

/* ─────────────────────────────────────────────────────────────
   DIMENSION / MEASURE TOGGLE BUTTON
   ───────────────────────────────────────────────────────────── */

.cfg-tool-row {
  position: absolute;
  bottom: 16px;
  left: 62px; /* 16px offset + 36px help-btn width + 10px gap */
  z-index: 10;
  display: flex;
  gap: 8px;
}

.cfg-measure-btn {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 8px 16px 8px 12px;
  background: rgba(10, 12, 22, 0.68);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 999px;
  color: rgba(180, 195, 220, 0.80);
  font-size: 12px;
  font-family: inherit;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: background 0.18s, border-color 0.18s, color 0.18s;
}

.cfg-measure-btn svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  opacity: 0.75;
  transition: opacity 0.18s;
}

.cfg-measure-btn:hover {
  background: rgba(100, 130, 255, 0.18);
  border-color: rgba(100, 130, 255, 0.38);
  color: rgba(200, 215, 255, 0.95);
}

.cfg-measure-btn:hover svg { opacity: 1; }

.cfg-measure-btn--active {
  background: rgba(80, 110, 255, 0.22);
  border-color: rgba(100, 140, 255, 0.55);
  color: rgba(180, 205, 255, 1.00);
}

.cfg-measure-btn--active svg { opacity: 1; }

/* ─────────────────────────────────────────────────────────────
   HOTSPOT MARKERS
   ───────────────────────────────────────────────────────────── */

.cfg-hotspot {
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 8;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: auto;
}

.cfg-hotspot__ring {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.90);
  border: 2px solid rgba(100, 130, 255, 0.80);
  box-shadow: 0 2px 12px rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.15s ease, background 0.15s ease;
  position: relative;
}

.cfg-hotspot__ring::after {
  content: '';
  position: absolute;
  inset: -6px;
  border-radius: 50%;
  border: 2px solid rgba(100, 130, 255, 0.40);
  animation: cfg-hotspot-pulse 2s ease-out infinite;
}

@keyframes cfg-hotspot-pulse {
  0%   { transform: scale(1);   opacity: 0.7; }
  100% { transform: scale(1.7); opacity: 0;   }
}

.cfg-hotspot__icon {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: rgba(100, 130, 255, 0.85);
}

.cfg-hotspot__label {
  position: absolute;
  bottom: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: rgba(10, 12, 22, 0.88);
  color: #fff;
  font-size: 0.70rem;
  font-family: inherit;
  font-weight: 500;
  white-space: nowrap;
  padding: 4px 9px;
  border-radius: 6px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.15s ease;
  border: 1px solid rgba(255,255,255,0.08);
}

.cfg-hotspot:hover .cfg-hotspot__label {
  opacity: 1;
}

.cfg-hotspot:hover .cfg-hotspot__ring {
  transform: scale(1.15);
  background: rgba(100, 130, 255, 0.85);
}

.cfg-hotspot:hover .cfg-hotspot__icon {
  background: #fff;
}

/* ─────────────────────────────────────────────────────────────
   RESPONSIVE — Tablet & Mobile (≤ 1024px)
   ───────────────────────────────────────────────────────────── */

/* ── Mobile bottom-bar layout (≤ 768px) ──────────────────── */
@media (max-width: 768px) {

  /* Panel wrap moves from top-right to bottom-right, grows upward */
  .cfg-panel-wrap {
    top: auto !important;
    bottom: 0;
    right: 0;
    padding: 0 12px 12px;
    flex-direction: column;
    align-items: flex-end;
  }

  /* Flyout doesn't work in bottom layout — hide it */
  .cfg-flyout {
    display: none !important;
  }

  /* Panel: fixed width, height grows upward naturally */
  .cfg-right-panel,
  .cfg-right-panel--expanded {
    width: min(400px, calc(100vw - 24px));
    transition: none;
  }

  /* Strip becomes a horizontal icon row — always visible on mobile */
  .cfg-strip-view {
    flex-direction: row;
    padding: 4px 6px;
    gap: 0;
    overflow-x: auto;
    scrollbar-width: none;
    order: 2;
  }
  .cfg-strip-view::-webkit-scrollbar { display: none; }

  /* Strip buttons compact in horizontal layout */
  .cfg-strip-btn {
    width: auto;
    padding: 8px 10px;
    min-width: 44px;
    flex-shrink: 0;
  }

  /* Divider becomes vertical in horizontal strip */
  .cfg-strip-divider {
    width: 1px;
    height: 22px;
    margin: 0 2px;
    align-self: center;
    flex-shrink: 0;
  }

  /* Toggle/expand button sits at the very bottom — acts as the handle */
  .cfg-panel-toggle-btn {
    order: 3;
    width: 100%;
    border-bottom: none;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 0 0 14px 14px;
    margin-bottom: 0;
    flex-direction: row;
    gap: 6px;
    padding: 10px 14px;
    justify-content: center;
  }

  /* Full panel content appears above the strip */
  .cfg-full-view {
    order: 1;
  }

  /* Tool-row (Dimensions + Hotspots) floats above the bottom bar */
  .cfg-tool-row {
    bottom: calc(var(--strip-h, 100px) + 8px);
    left: 16px;
    right: auto;
    transition: bottom 0.22s cubic-bezier(0.4, 0, 0.2, 1);
  }

  /* Help button (?) aligns with tool-row, same bottom offset */
  .cfg-center .guide-help-btn {
    bottom: calc(var(--strip-h, 100px) + 8px) !important;
  }
}

@media (max-width: 1024px) {
  .cfg-wrapper {
    flex-direction: column;
  }

  /* Left panel → horizontal top bar */
  .cfg-left-panel {
    width: 100%;
    min-width: 0;
    flex-direction: row;
    align-items: center;
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    overflow-x: auto;
    overflow-y: hidden;
    flex-shrink: 0;
    scrollbar-width: none;
  }

  .cfg-left-panel::-webkit-scrollbar { display: none; }

  .cfg-left-header,
  .cfg-left-footer {
    display: none;
  }

  .cfg-card-list {
    flex-direction: row;
    padding: 8px 12px;
    gap: 8px;
    overflow-x: auto;
    overflow-y: hidden;
  }

  .cfg-card {
    flex-direction: column;
    align-items: center;
    min-width: 90px;
    padding: 10px 12px;
    gap: 8px;
  }

  .cfg-card__thumb {
    width: 48px;
    height: 40px;
  }

  .cfg-card__sub,
  .cfg-card__dots {
    display: none;
  }

  .cfg-card__name {
    font-size: 0.72rem;
  }

  /* Center canvas */
  .cfg-center {
    flex: 1;
    min-height: 0;
  }

  /* Right panel wrap repositions on tablet */
  .cfg-panel-wrap {
    top: 10px;
    right: 10px;
  }

  /* Show collapse toggle in mobile */
  .cfg-panel-toggle {
    display: flex;
    flex-shrink: 0;
    width: 100%;
    margin-bottom: 8px;
    padding: 12px 18px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }
}

@media (max-width: 520px) {
  .cfg-panel-wrap {
    right: 8px;
    top: 8px;
  }

  .cfg-right-panel--expanded {
    width: calc(100vw - 96px); /* leave room for strip + gap */
  }

  .cfg-card {
    min-width: 72px;
    padding: 8px 10px;
  }

  .cfg-card__thumb {
    width: 38px;
    height: 32px;
  }
}

/* ── Coming soon overlay ─────────────────────────────────── */
.cfg-coming-soon {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.4s ease;
  z-index: 30;
}

.cfg-coming-soon--visible {
  opacity: 1;
}

.cfg-coming-soon__title {
  font-family: 'Montserrat', system-ui, sans-serif;
  font-weight: 700;
  font-size: 36px;
  letter-spacing: -0.5px;
  color: #ffffff;
  margin: 0;
  text-shadow:
    1px  1px 0 rgba(0,0,0,0.4),
   -1px -1px 0 rgba(0,0,0,0.4),
    0 0 20px rgba(0,0,0,0.3);
}

.cfg-coming-soon__sub {
  font-family: 'Montserrat', system-ui, sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 1.7;
  text-align: center;
  color: rgba(200, 206, 222, 0.75);
  margin: 0;
  text-shadow: 0 1px 6px rgba(0,0,0,0.4);
}

/* ── Hotspot info panel ───────────────────────────────────── */
.cfg-hotspot-info {
  position: absolute;
  left: 36px;
  top: 50%;
  transform: translateY(-50%) translateX(-18px);
  width: 260px;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.5s ease, transform 0.5s ease;
  z-index: 20;
  user-select: none;
  mix-blend-mode: difference;
}

.cfg-hotspot-info--visible {
  opacity: 1;
  transform: translateY(-50%) translateX(0);
}

.cfg-hotspot-info__title {
  font-family: 'Montserrat', system-ui, sans-serif;
  font-weight: 700;
  font-size: 28px;
  line-height: 1.1;
  letter-spacing: -0.5px;
  color: #ffffff;
  margin: 0 0 14px 0;
}

.cfg-hotspot-info__body {
  font-family: 'Montserrat', system-ui, sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 1.65;
  color: #c8cede;
  margin: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main.css"],"names":[],"mappings":"AAAA;;;;;;;EAOE;;AAEF,gEAAgE;AAChE;;;;EAIE,sBAAsB;AACxB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB;gCAC8B;EAC9B,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;;kEAEkE;;AAElE;EACE,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,6DAA6D;EAC7D,iDAAiD;EACjD,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,OAAO;EACP,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,UAAU;AACZ;AACA;EACE,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,eAAe;EACf,8EAA8E;EAC9E,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,+EAA+E;EAC/E,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,6DAA6D;AAC/D;;AAEA;EACE,aAAa;AACf;;AAEA,oBAAoB;AACpB;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,4BAA4B;AAC5B;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yEAAyE;EACzE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;kEAEkE;;AAElE;EACE,OAAO;EACP,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;AACd;;AAEA;;kEAEkE;;AAElE,sEAAsE;AACtE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;AACb;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,mFAAmF;EACnF,oDAAoD;AACtD;;AAEA;EACE,YAAY;AACd;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;EACR,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;AACb;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,mFAAmF;EACnF,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,yDAAyD;AAC3D;;AAEA,mDAAmD;AACnD;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,kDAAkD;EAClD,gCAAgC;EAChC,eAAe;EACf,yCAAyC;EACzC,cAAc;EACd,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,yCAAyC;EACzC,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA,qDAAqD;AACrD;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,6CAA6C;EAC7C,qCAAqC;EACrC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,UAAU;EACV,WAAW;EACX,qCAAqC;EACrC,aAAa;EACb,cAAc;AAChB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,mFAAmF;EACnF,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA,+DAA+D;AAC/D;;EAEE,YAAY;AACd;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,4CAA4C;AAC9C;;;AAGA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,UAAU;EACV,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,6CAA6C;EAC7C;;;iCAG+B;EAC/B,uDAAuD;AACzD;;AAEA;EACE,uCAAuC;EACvC;;;kCAGgC;AAClC;;AAEA;;EAEE,uCAAuC;EACvC;;;;uCAIqC;AACvC;;AAEA,yCAAyC;AACzC;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,0BAA0B;EAC1B,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,yDAAgS;EAChS,4BAA4B;EAC5B,sCAAsC;EACtC,sDAAsD;EACtD,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,2CAA2C;AAC7C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,qCAAqC;EACrC,aAAa;EACb,cAAc;AAChB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,8FAA8F;EAC9F,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,6DAA6D;EAC7D,aAAa;AACf;;AAEA;EACE,8FAA8F;EAC9F,uCAAuC;EACvC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,yCAAyC;AACzC;EACE,aAAa,EAAE,sCAAsC;EACrD,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,uBAAuB;EACvB,YAAY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;;AAGA,gEAAgE;AAChE;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;EAChC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;kEAEkE;;AAElE;EACE,kBAAkB;EAClB,QAAQ;EACR,kCAAkC;EAClC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2CAA2C;EAC3C,2CAA2C;EAC3C,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;;kEAEkE;;AAElE;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,UAAU;EACV,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,oCAAoC;EACpC,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;;kEAEkE;;AAElE;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,2CAA2C;EAC3C,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;;kEAEkE;;AAElE;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU,EAAE,iDAAiD;EAC7D,WAAW;EACX,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,kCAAkC;EAClC,0BAA0B;EAC1B,kCAAkC;EAClC,2CAA2C;EAC3C,oBAAoB;EACpB,gCAAgC;EAChC,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,6BAA6B,UAAU,EAAE;;AAEzC;EACE,oCAAoC;EACpC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA,+BAA+B,UAAU,EAAE;;AAE3C;;kEAEkE;;AAElE;EACE,kBAAkB;EAClB,gCAAgC;EAChC,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,2CAA2C;EAC3C,uCAAuC;EACvC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;EACvD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,2CAA2C;EAC3C,iDAAiD;AACnD;;AAEA;EACE,OAAO,mBAAmB,IAAI,YAAY,EAAE;EAC5C,OAAO,qBAAqB,EAAE,UAAU,IAAI;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,WAAW;EACX,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,UAAU;EACV,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;kEAEkE;;AAElE,+DAA+D;AAC/D;;EAEE,kEAAkE;EAClE;IACE,oBAAoB;IACpB,SAAS;IACT,QAAQ;IACR,oBAAoB;IACpB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA,mDAAmD;EACnD;IACE,wBAAwB;EAC1B;;EAEA,sDAAsD;EACtD;;IAEE,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA,mEAAmE;EACnE;IACE,mBAAmB;IACnB,gBAAgB;IAChB,MAAM;IACN,gBAAgB;IAChB,qBAAqB;IACrB,QAAQ;EACV;EACA,qCAAqC,aAAa,EAAE;;EAEpD,+CAA+C;EAC/C;IACE,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,cAAc;EAChB;;EAEA,iDAAiD;EACjD;IACE,UAAU;IACV,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,cAAc;EAChB;;EAEA,sEAAsE;EACtE;IACE,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,+CAA+C;IAC/C,4BAA4B;IAC5B,gBAAgB;IAChB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA,+CAA+C;EAC/C;IACE,QAAQ;EACV;;EAEA,iEAAiE;EACjE;IACE,yCAAyC;IACzC,UAAU;IACV,WAAW;IACX,qDAAqD;EACvD;;EAEA,6DAA6D;EAC7D;IACE,oDAAoD;EACtD;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA,oCAAoC;EACpC;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,kDAAkD;IAClD,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;EACvB;;EAEA,qCAAqC,aAAa,EAAE;;EAEpD;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA,kBAAkB;EAClB;IACE,OAAO;IACP,aAAa;EACf;;EAEA,2CAA2C;EAC3C;IACE,SAAS;IACT,WAAW;EACb;;EAEA,mCAAmC;EACnC;IACE,aAAa;IACb,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,+CAA+C;EACjD;AACF;;AAEA;EACE;IACE,UAAU;IACV,QAAQ;EACV;;EAEA;IACE,yBAAyB,EAAE,+BAA+B;EAC5D;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,SAAS;EACT;;;4BAG0B;AAC5B;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;EAChC,SAAS;EACT,sCAAsC;AACxC;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,6CAA6C;EAC7C,YAAY;EACZ,oBAAoB;EACpB,UAAU;EACV,kDAAkD;EAClD,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gDAAgD;EAChD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX","sourcesContent":["/*\n * ============================================================\n *  3D Configurator — Premium Dark UI Styles\n *\n *  Every selector is prefixed with .cfg- to prevent leaking\n *  into the host page. No global resets are applied here.\n * ============================================================\n */\n\n/* ── Box-sizing reset scoped to our component ─────────────── */\n.cfg-wrapper,\n.cfg-wrapper *,\n.cfg-wrapper *::before,\n.cfg-wrapper *::after {\n  box-sizing: border-box;\n}\n\n/* ── Root wrapper (flex container) ───────────────────────── */\n.cfg-wrapper {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  min-height: 480px;\n  position: relative;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI',\n    Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  color: #e0e0e0;\n  background: #0a0c14;\n  overflow: hidden;\n}\n\n/* ─────────────────────────────────────────────────────────────\n   LEFT PANEL — product card navigation\n   ───────────────────────────────────────────────────────────── */\n\n.cfg-left-panel {\n  width: 340px;\n  min-width: 260px;\n  flex-shrink: 0;\n  background: linear-gradient(180deg, #0d0f1c 0%, #0a0c14 100%);\n  border-right: 1px solid rgba(255, 255, 255, 0.06);\n  display: flex;\n  flex-direction: column;\n  z-index: 2;\n  overflow: hidden;\n}\n\n/* ── Left panel header ── */\n.cfg-left-header {\n  padding: 32px 28px 20px;\n  flex-shrink: 0;\n}\n\n.cfg-left-eyebrow {\n  font-size: 0.62rem;\n  font-weight: 600;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: rgba(160, 180, 255, 0.55);\n  margin: 0 0 10px;\n}\n\n.cfg-left-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0;\n  line-height: 1.25;\n  letter-spacing: -0.01em;\n}\n\n/* ── Product card list ── */\n.cfg-card-list {\n  flex: 1;\n  padding: 4px 16px 16px;\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow-y: auto;\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255,255,255,0.08) transparent;\n}\n\n.cfg-card-list::-webkit-scrollbar {\n  width: 4px;\n}\n.cfg-card-list::-webkit-scrollbar-thumb {\n  background: rgba(255,255,255,0.10);\n  border-radius: 2px;\n}\n\n/* ── Individual product card ── */\n.cfg-card {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 14px 16px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 14px;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, transform 0.15s ease;\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  text-align: left;\n  font-family: inherit;\n  color: inherit;\n}\n\n.cfg-card:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.06);\n  border-color: rgba(255, 255, 255, 0.12);\n}\n\n.cfg-card--active {\n  background: rgba(100, 130, 255, 0.08);\n  border-color: rgba(100, 130, 255, 0.30);\n}\n\n.cfg-card--active::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(135deg, rgba(100,130,255,0.06) 0%, transparent 60%);\n  pointer-events: none;\n}\n\n.cfg-card:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n/* ── Card thumbnail ── */\n.cfg-card__thumb {\n  width: 72px;\n  height: 60px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #1a1e32 0%, #0f1220 100%);\n  border: 1px solid rgba(255,255,255,0.07);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.cfg-card__thumb svg {\n  width: 36px;\n  height: 36px;\n  opacity: 0.55;\n  color: rgba(160, 180, 255, 0.8);\n}\n\n.cfg-card--active .cfg-card__thumb {\n  border-color: rgba(100, 130, 255, 0.25);\n  background: linear-gradient(135deg, #1e2540 0%, #131828 100%);\n}\n\n.cfg-card--active .cfg-card__thumb svg {\n  opacity: 0.85;\n}\n\n/* ── Card text ── */\n.cfg-card__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.cfg-card__name {\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: #e0e4f0;\n  margin: 0 0 4px;\n  line-height: 1.2;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cfg-card--active .cfg-card__name {\n  color: #ffffff;\n}\n\n.cfg-card__sub {\n  font-size: 0.72rem;\n  color: rgba(255, 255, 255, 0.35);\n  margin: 0 0 10px;\n  line-height: 1.3;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ── Card indicator dots ── */\n.cfg-card__dots {\n  display: flex;\n  gap: 5px;\n}\n\n.cfg-card__dot {\n  width: 6px;\n  height: 6px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.cfg-card--active .cfg-card__dot:first-child {\n  background: rgba(120, 150, 255, 0.75);\n}\n\n.cfg-card--active .cfg-card__dot:nth-child(2) {\n  background: rgba(120, 150, 255, 0.45);\n}\n\n/* ── Left panel footer ── */\n.cfg-left-footer {\n  padding: 20px 28px 28px;\n  border-top: 1px solid rgba(255, 255, 255, 0.06);\n  flex-shrink: 0;\n}\n\n.cfg-left-footer__desc {\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.30);\n  line-height: 1.5;\n  margin: 0 0 16px;\n}\n\n.cfg-explore-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 22px;\n  background: rgba(100, 130, 255, 0.12);\n  border: 1px solid rgba(100, 130, 255, 0.30);\n  border-radius: 999px;\n  color: rgba(160, 180, 255, 0.9);\n  font-size: 0.78rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.2s ease, border-color 0.2s ease, color 0.2s ease;\n  white-space: nowrap;\n  letter-spacing: 0.02em;\n}\n\n.cfg-explore-btn:hover {\n  background: rgba(100, 130, 255, 0.22);\n  border-color: rgba(100, 130, 255, 0.55);\n  color: #fff;\n}\n\n.cfg-explore-btn svg {\n  width: 13px;\n  height: 13px;\n}\n\n.cfg-left-footer__contact {\n  font-size: 0.68rem;\n  color: rgba(255, 255, 255, 0.20);\n  margin: 12px 0 0;\n}\n\n.cfg-left-footer__contact a {\n  color: rgba(160, 180, 255, 0.45);\n  text-decoration: none;\n}\n\n.cfg-left-footer__contact a:hover {\n  color: rgba(160, 180, 255, 0.75);\n}\n\n/* ─────────────────────────────────────────────────────────────\n   CENTRE (canvas area)\n   ───────────────────────────────────────────────────────────── */\n\n.cfg-center {\n  flex: 1;\n  position: relative;\n  overflow: hidden;\n  background: #0a0c14;\n}\n\n.cfg-canvas {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n\n/* ─────────────────────────────────────────────────────────────\n   RIGHT PANEL — floating overlay (position: absolute inside center)\n   ───────────────────────────────────────────────────────────── */\n\n/* ── Outer wrapper — flyout grows left, panel stays on the right ── */\n.cfg-panel-wrap {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 8px;\n  z-index: 20;\n}\n\n/* ── Single panel — collapses to narrow strip, expands in-place ── */\n.cfg-right-panel {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 68px;\n  overflow: hidden;\n  background: rgba(10, 12, 22, 0.82);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50), 0 0 0 1px rgba(255,255,255,0.03) inset;\n  transition: width 0.22s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.cfg-right-panel--expanded {\n  width: 242px;\n}\n\n/* ── Collapsed view — icon strip ── */\n.cfg-strip-view {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 4px 6px 8px;\n  gap: 2px;\n  width: 100%;\n}\n\n/* ── Expanded view — full panel content ── */\n.cfg-full-view {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  width: 100%;\n}\n\n/* ── Flyout (single-section popout, shown while panel is collapsed) ── */\n.cfg-flyout {\n  display: flex;\n  flex-direction: column;\n  background: rgba(10, 12, 22, 0.82);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50), 0 0 0 1px rgba(255,255,255,0.03) inset;\n  width: 200px;\n  overflow: hidden;\n  align-self: flex-start;\n  transition: margin-top 0.18s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n/* ── Expand / collapse toggle at top of strip ── */\n.cfg-panel-toggle-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 52px;\n  padding: 8px 4px;\n  background: transparent;\n  border: none;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  color: rgba(255, 255, 255, 0.40);\n  cursor: pointer;\n  transition: color 0.15s, background 0.15s;\n  flex-shrink: 0;\n  font-family: inherit;\n  border-radius: 8px 8px 0 0;\n  margin-bottom: 2px;\n  width: 100%;\n}\n\n.cfg-panel-toggle-btn:hover {\n  color: rgba(255, 255, 255, 0.85);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.cfg-panel-toggle-btn svg {\n  width: 15px;\n  height: 15px;\n}\n\n/* ── Icon + label buttons in strip ── */\n.cfg-strip-btn {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 100%;\n  padding: 7px 4px;\n  background: transparent;\n  border: none;\n  border-radius: 10px;\n  color: rgba(255, 255, 255, 0.42);\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n  flex-shrink: 0;\n  font-family: inherit;\n}\n\n.cfg-strip-btn:hover {\n  background: rgba(255, 255, 255, 0.07);\n  color: rgba(255, 255, 255, 0.85);\n}\n\n.cfg-strip-btn--active {\n  background: rgba(100, 130, 255, 0.15);\n  color: rgba(160, 180, 255, 0.95);\n}\n\n/* Pinned = clicked open, stays until clicked again */\n.cfg-strip-btn--pinned {\n  background: rgba(100, 130, 255, 0.22);\n  color: rgba(180, 200, 255, 1);\n  border-radius: 10px;\n  box-shadow: inset 0 0 0 1px rgba(120, 150, 255, 0.35);\n}\n\n.cfg-strip-btn svg {\n  width: 15px;\n  height: 15px;\n  flex-shrink: 0;\n}\n\n.cfg-colour-strip-globe {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  border: 1.5px solid rgba(255, 255, 255, 0.18);\n  box-shadow: 0 1px 4px rgba(0,0,0,0.4);\n  transition: background 0.25s ease;\n}\n\n.cfg-strip-btn__label {\n  font-size: 0.52rem;\n  font-weight: 500;\n  letter-spacing: 0.03em;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n}\n\n/* ── Divider between section icons and action icons ── */\n.cfg-strip-divider {\n  width: 70%;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.07);\n  margin: 4px 0;\n  flex-shrink: 0;\n}\n\n/* ── Legacy .cfg-side-panel (kept for any lingering refs) ── */\n.cfg-side-panel {\n  display: flex;\n  flex-direction: column;\n  background: rgba(10, 12, 22, 0.82);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.50), 0 0 0 1px rgba(255,255,255,0.03) inset;\n  overflow: hidden;\n  width: 200px;\n}\n\n.cfg-side-panel--expanded {\n  width: 242px;\n}\n\n/* ── Flyout title ── */\n.cfg-flyout-title {\n  font-size: 0.60rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.30);\n  margin: 0 0 10px;\n  padding: 12px 14px 0;\n}\n\n/* ── Full panel inner scroll area ── */\n.cfg-panel-content-inner {\n  padding: 11px 14px 14px;\n  display: flex;\n  flex-direction: column;\n  gap: 11px;\n  overflow-y: auto;\n  max-height: calc(100vh - 100px);\n  scrollbar-width: none;\n}\n\n.cfg-panel-content-inner::-webkit-scrollbar {\n  display: none;\n}\n\n/* Flyout content padding (no title, so pad all sides evenly) */\n.cfg-flyout .cfg-color-grid,\n.cfg-flyout .cfg-variant-list {\n  margin: 12px;\n}\n\n/* ── Panel header ── */\n.cfg-panel-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 11px 14px 10px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n  flex-shrink: 0;\n}\n\n.cfg-panel-header__title {\n  font-size: 0.82rem;\n  font-weight: 700;\n  color: #ffffff;\n  letter-spacing: 0.02em;\n  margin: 0;\n}\n\n.cfg-panel-header__dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: rgba(100, 200, 120, 0.75);\n  box-shadow: 0 0 6px rgba(100, 200, 120, 0.5);\n}\n\n\n/* ── Section labels ── */\n.cfg-section-label {\n  font-size: 0.60rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.30);\n  margin: 0 0 10px;\n}\n\n/* ── Colour swatches — 3D globe style ── */\n.cfg-color-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.cfg-color-swatch {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: none;\n  outline: none;\n  padding: 0;\n  cursor: pointer;\n  position: relative;\n  flex-shrink: 0;\n  /* depth shadow to sell the sphere illusion */\n  box-shadow:\n    inset -2px -3px 5px rgba(0, 0, 0, 0.28),\n    inset 1px 1px 2px rgba(255, 255, 255, 0.10),\n    0 3px 8px rgba(0, 0, 0, 0.40);\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.cfg-color-swatch:hover {\n  transform: scale(1.18) translateY(-1px);\n  box-shadow:\n    inset -2px -3px 5px rgba(0, 0, 0, 0.28),\n    inset 1px 1px 2px rgba(255, 255, 255, 0.10),\n    0 6px 14px rgba(0, 0, 0, 0.50);\n}\n\n.cfg-color-swatch--active,\n.cfg-color-swatch--active:hover {\n  transform: scale(1.18) translateY(-1px);\n  box-shadow:\n    inset -2px -3px 5px rgba(0, 0, 0, 0.28),\n    inset 1px 1px 2px rgba(255, 255, 255, 0.10),\n    0 6px 14px rgba(0, 0, 0, 0.50),\n    0 0 0 2px rgba(255, 255, 255, 0.75);\n}\n\n/* ── Variant buttons (side by side) ── */\n.cfg-variant-list {\n  display: flex;\n  gap: 8px;\n}\n\n.cfg-variant-btn {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  padding: 8px 6px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  border-radius: 8px;\n  color: rgba(255, 255, 255, 0.50);\n  font-size: 0.75rem;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  text-align: center;\n  transition: background 0.18s, color 0.18s, border-color 0.18s;\n}\n\n.cfg-variant-btn__icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  opacity: 0.65;\n  flex-shrink: 0;\n}\n\n.cfg-variant-btn__icon svg {\n  width: 100%;\n  height: 100%;\n}\n\n.cfg-variant-btn__label {\n  line-height: 1;\n}\n\n.cfg-variant-btn--active .cfg-variant-btn__icon {\n  opacity: 1;\n}\n\n.cfg-variant-btn:hover {\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.80);\n}\n\n.cfg-variant-btn--active {\n  background: rgba(100, 130, 255, 0.15);\n  border-color: rgba(100, 130, 255, 0.40);\n  color: rgba(160, 180, 255, 0.95);\n}\n\n/* ── AA Select ── */\n.cfg-aa-select {\n  width: 100%;\n  padding: 7px 28px 7px 10px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.09);\n  border-radius: 8px;\n  color: rgba(255, 255, 255, 0.70);\n  font-size: 0.78rem;\n  font-family: inherit;\n  cursor: pointer;\n  appearance: none;\n  -webkit-appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='rgba(255,255,255,0.35)' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 10px center;\n  transition: border-color 0.18s, background-color 0.18s;\n  outline: none;\n}\n\n.cfg-aa-select:hover {\n  border-color: rgba(255, 255, 255, 0.18);\n  background-color: rgba(255, 255, 255, 0.08);\n}\n\n.cfg-aa-select:focus {\n  border-color: rgba(100, 130, 255, 0.45);\n}\n\n.cfg-aa-select option {\n  background: #111420;\n  color: #e0e4f0;\n}\n\n/* ── Divider ── */\n.cfg-divider {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.06);\n  margin: 2px 0;\n  flex-shrink: 0;\n}\n\n/* ── Reset camera button ── */\n.cfg-reset-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 7px 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  border-radius: 9px;\n  color: rgba(255, 255, 255, 0.60);\n  font-size: 0.78rem;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  width: 100%;\n  transition: background 0.18s, color 0.18s, border-color 0.18s;\n}\n\n.cfg-reset-btn:hover {\n  background: rgba(255, 255, 255, 0.10);\n  color: rgba(255, 255, 255, 0.90);\n  border-color: rgba(255, 255, 255, 0.20);\n}\n\n.cfg-reset-btn svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n\n/* ── Fullscreen button ── */\n.cfg-fullscreen-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 7px 12px;\n  background: linear-gradient(135deg, rgba(60, 100, 255, 0.55) 0%, rgba(40, 70, 220, 0.55) 100%);\n  border: 1px solid rgba(100, 140, 255, 0.35);\n  border-radius: 9px;\n  color: rgba(200, 215, 255, 0.95);\n  font-size: 0.78rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  width: 100%;\n  transition: background 0.18s, border-color 0.18s, color 0.18s;\n  margin-top: 0;\n}\n\n.cfg-fullscreen-btn:hover {\n  background: linear-gradient(135deg, rgba(80, 120, 255, 0.70) 0%, rgba(60, 90, 240, 0.70) 100%);\n  border-color: rgba(130, 160, 255, 0.55);\n  color: #fff;\n}\n\n.cfg-fullscreen-btn svg {\n  width: 14px;\n  height: 14px;\n  flex-shrink: 0;\n}\n\n/* ── Bottom icon buttons row ── */\n.cfg-icon-row {\n  display: flex;\n  gap: 8px;\n  margin-top: 2px;\n}\n\n.cfg-icon-btn {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 7px;\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 9px;\n  color: rgba(255, 255, 255, 0.45);\n  cursor: pointer;\n  transition: background 0.18s, color 0.18s, border-color 0.18s;\n}\n\n.cfg-icon-btn:hover {\n  background: rgba(255, 255, 255, 0.09);\n  color: rgba(255, 255, 255, 0.80);\n  border-color: rgba(255, 255, 255, 0.16);\n}\n\n.cfg-icon-btn svg {\n  width: 15px;\n  height: 15px;\n}\n\n/* ── Panel section separator ── */\n.cfg-panel-section {\n  display: flex;\n  flex-direction: column;\n}\n\n/* ── Panel toggle (collapse header) ── */\n.cfg-panel-toggle {\n  display: none; /* desktop: hidden, mobile uses this */\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0;\n  background: transparent;\n  border: none;\n  color: rgba(255, 255, 255, 0.30);\n  font-size: 0.60rem;\n  font-weight: 700;\n  letter-spacing: 0.10em;\n  text-transform: uppercase;\n  cursor: pointer;\n  font-family: inherit;\n}\n\n.cfg-panel-toggle-icon {\n  font-style: normal;\n  font-size: 0.75rem;\n  transition: transform 0.2s ease;\n}\n\n\n/* ── Old panel title class (kept for rightPanel.ts compat) ── */\n.cfg-panel-title {\n  margin: 0 0 8px;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.30);\n  padding-bottom: 0;\n  border-bottom: none;\n}\n\n/* ─────────────────────────────────────────────────────────────\n   LOADING OVERLAY\n   ───────────────────────────────────────────────────────────── */\n\n.cfg-loading-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(10, 12, 20, 0.80);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  z-index: 50;\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n}\n\n.cfg-spinner {\n  width: 36px;\n  height: 36px;\n  border: 2px solid rgba(255, 255, 255, 0.08);\n  border-top-color: rgba(100, 130, 255, 0.80);\n  border-radius: 50%;\n  animation: cfg-spin 0.75s linear infinite;\n}\n\n@keyframes cfg-spin {\n  to { transform: rotate(360deg); }\n}\n\n.cfg-loading-text {\n  font-size: 0.75rem;\n  color: rgba(255, 255, 255, 0.30);\n  letter-spacing: 0.06em;\n}\n\n/* ─────────────────────────────────────────────────────────────\n   VARIANT LOADER  (small floating indicator, not full overlay)\n   ───────────────────────────────────────────────────────────── */\n\n.cfg-variant-loader {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -70%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.28s ease;\n  z-index: 10;\n}\n\n.cfg-variant-loader--visible {\n  opacity: 1;\n}\n\n.cfg-variant-loader .cfg-spinner {\n  width: 26px;\n  height: 26px;\n  border-width: 2px;\n  border-color: rgba(255,255,255,0.06);\n  border-top-color: rgba(140, 160, 255, 0.85);\n}\n\n.cfg-variant-loader .cfg-loading-text {\n  font-size: 0.68rem;\n  color: rgba(255, 255, 255, 0.22);\n}\n\n/* ─────────────────────────────────────────────────────────────\n   FOCUS RESET BUTTON (viewport overlay)\n   ───────────────────────────────────────────────────────────── */\n\n.cfg-focus-reset-btn {\n  position: absolute;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 10;\n  display: none;\n  align-items: center;\n  gap: 6px;\n  padding: 9px 20px;\n  background: rgba(10, 12, 22, 0.72);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 1px solid rgba(100, 130, 255, 0.40);\n  border-radius: 999px;\n  color: rgba(160, 180, 255, 0.90);\n  font-size: 13px;\n  font-family: inherit;\n  font-weight: 500;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.18s, color 0.18s;\n}\n\n.cfg-focus-reset-btn:hover {\n  background: rgba(100, 130, 255, 0.25);\n  color: #fff;\n}\n\n/* ─────────────────────────────────────────────────────────────\n   DIMENSION / MEASURE TOGGLE BUTTON\n   ───────────────────────────────────────────────────────────── */\n\n.cfg-tool-row {\n  position: absolute;\n  bottom: 16px;\n  left: 62px; /* 16px offset + 36px help-btn width + 10px gap */\n  z-index: 10;\n  display: flex;\n  gap: 8px;\n}\n\n.cfg-measure-btn {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 8px 16px 8px 12px;\n  background: rgba(10, 12, 22, 0.68);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  border-radius: 999px;\n  color: rgba(180, 195, 220, 0.80);\n  font-size: 12px;\n  font-family: inherit;\n  font-weight: 500;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: background 0.18s, border-color 0.18s, color 0.18s;\n}\n\n.cfg-measure-btn svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  opacity: 0.75;\n  transition: opacity 0.18s;\n}\n\n.cfg-measure-btn:hover {\n  background: rgba(100, 130, 255, 0.18);\n  border-color: rgba(100, 130, 255, 0.38);\n  color: rgba(200, 215, 255, 0.95);\n}\n\n.cfg-measure-btn:hover svg { opacity: 1; }\n\n.cfg-measure-btn--active {\n  background: rgba(80, 110, 255, 0.22);\n  border-color: rgba(100, 140, 255, 0.55);\n  color: rgba(180, 205, 255, 1.00);\n}\n\n.cfg-measure-btn--active svg { opacity: 1; }\n\n/* ─────────────────────────────────────────────────────────────\n   HOTSPOT MARKERS\n   ───────────────────────────────────────────────────────────── */\n\n.cfg-hotspot {\n  position: absolute;\n  transform: translate(-50%, -50%);\n  z-index: 8;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto;\n}\n\n.cfg-hotspot__ring {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.90);\n  border: 2px solid rgba(100, 130, 255, 0.80);\n  box-shadow: 0 2px 12px rgba(0,0,0,0.25);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: transform 0.15s ease, background 0.15s ease;\n  position: relative;\n}\n\n.cfg-hotspot__ring::after {\n  content: '';\n  position: absolute;\n  inset: -6px;\n  border-radius: 50%;\n  border: 2px solid rgba(100, 130, 255, 0.40);\n  animation: cfg-hotspot-pulse 2s ease-out infinite;\n}\n\n@keyframes cfg-hotspot-pulse {\n  0%   { transform: scale(1);   opacity: 0.7; }\n  100% { transform: scale(1.7); opacity: 0;   }\n}\n\n.cfg-hotspot__icon {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: rgba(100, 130, 255, 0.85);\n}\n\n.cfg-hotspot__label {\n  position: absolute;\n  bottom: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(10, 12, 22, 0.88);\n  color: #fff;\n  font-size: 0.70rem;\n  font-family: inherit;\n  font-weight: 500;\n  white-space: nowrap;\n  padding: 4px 9px;\n  border-radius: 6px;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.15s ease;\n  border: 1px solid rgba(255,255,255,0.08);\n}\n\n.cfg-hotspot:hover .cfg-hotspot__label {\n  opacity: 1;\n}\n\n.cfg-hotspot:hover .cfg-hotspot__ring {\n  transform: scale(1.15);\n  background: rgba(100, 130, 255, 0.85);\n}\n\n.cfg-hotspot:hover .cfg-hotspot__icon {\n  background: #fff;\n}\n\n/* ─────────────────────────────────────────────────────────────\n   RESPONSIVE — Tablet & Mobile (≤ 1024px)\n   ───────────────────────────────────────────────────────────── */\n\n/* ── Mobile bottom-bar layout (≤ 768px) ──────────────────── */\n@media (max-width: 768px) {\n\n  /* Panel wrap moves from top-right to bottom-right, grows upward */\n  .cfg-panel-wrap {\n    top: auto !important;\n    bottom: 0;\n    right: 0;\n    padding: 0 12px 12px;\n    flex-direction: column;\n    align-items: flex-end;\n  }\n\n  /* Flyout doesn't work in bottom layout — hide it */\n  .cfg-flyout {\n    display: none !important;\n  }\n\n  /* Panel: fixed width, height grows upward naturally */\n  .cfg-right-panel,\n  .cfg-right-panel--expanded {\n    width: min(400px, calc(100vw - 24px));\n    transition: none;\n  }\n\n  /* Strip becomes a horizontal icon row — always visible on mobile */\n  .cfg-strip-view {\n    flex-direction: row;\n    padding: 4px 6px;\n    gap: 0;\n    overflow-x: auto;\n    scrollbar-width: none;\n    order: 2;\n  }\n  .cfg-strip-view::-webkit-scrollbar { display: none; }\n\n  /* Strip buttons compact in horizontal layout */\n  .cfg-strip-btn {\n    width: auto;\n    padding: 8px 10px;\n    min-width: 44px;\n    flex-shrink: 0;\n  }\n\n  /* Divider becomes vertical in horizontal strip */\n  .cfg-strip-divider {\n    width: 1px;\n    height: 22px;\n    margin: 0 2px;\n    align-self: center;\n    flex-shrink: 0;\n  }\n\n  /* Toggle/expand button sits at the very bottom — acts as the handle */\n  .cfg-panel-toggle-btn {\n    order: 3;\n    width: 100%;\n    border-bottom: none;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 0 0 14px 14px;\n    margin-bottom: 0;\n    flex-direction: row;\n    gap: 6px;\n    padding: 10px 14px;\n    justify-content: center;\n  }\n\n  /* Full panel content appears above the strip */\n  .cfg-full-view {\n    order: 1;\n  }\n\n  /* Tool-row (Dimensions + Hotspots) floats above the bottom bar */\n  .cfg-tool-row {\n    bottom: calc(var(--strip-h, 100px) + 8px);\n    left: 16px;\n    right: auto;\n    transition: bottom 0.22s cubic-bezier(0.4, 0, 0.2, 1);\n  }\n\n  /* Help button (?) aligns with tool-row, same bottom offset */\n  .cfg-center .guide-help-btn {\n    bottom: calc(var(--strip-h, 100px) + 8px) !important;\n  }\n}\n\n@media (max-width: 1024px) {\n  .cfg-wrapper {\n    flex-direction: column;\n  }\n\n  /* Left panel → horizontal top bar */\n  .cfg-left-panel {\n    width: 100%;\n    min-width: 0;\n    flex-direction: row;\n    align-items: center;\n    border-right: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    overflow-x: auto;\n    overflow-y: hidden;\n    flex-shrink: 0;\n    scrollbar-width: none;\n  }\n\n  .cfg-left-panel::-webkit-scrollbar { display: none; }\n\n  .cfg-left-header,\n  .cfg-left-footer {\n    display: none;\n  }\n\n  .cfg-card-list {\n    flex-direction: row;\n    padding: 8px 12px;\n    gap: 8px;\n    overflow-x: auto;\n    overflow-y: hidden;\n  }\n\n  .cfg-card {\n    flex-direction: column;\n    align-items: center;\n    min-width: 90px;\n    padding: 10px 12px;\n    gap: 8px;\n  }\n\n  .cfg-card__thumb {\n    width: 48px;\n    height: 40px;\n  }\n\n  .cfg-card__sub,\n  .cfg-card__dots {\n    display: none;\n  }\n\n  .cfg-card__name {\n    font-size: 0.72rem;\n  }\n\n  /* Center canvas */\n  .cfg-center {\n    flex: 1;\n    min-height: 0;\n  }\n\n  /* Right panel wrap repositions on tablet */\n  .cfg-panel-wrap {\n    top: 10px;\n    right: 10px;\n  }\n\n  /* Show collapse toggle in mobile */\n  .cfg-panel-toggle {\n    display: flex;\n    flex-shrink: 0;\n    width: 100%;\n    margin-bottom: 8px;\n    padding: 12px 18px;\n    border-bottom: 1px solid rgba(255,255,255,0.06);\n  }\n}\n\n@media (max-width: 520px) {\n  .cfg-panel-wrap {\n    right: 8px;\n    top: 8px;\n  }\n\n  .cfg-right-panel--expanded {\n    width: calc(100vw - 96px); /* leave room for strip + gap */\n  }\n\n  .cfg-card {\n    min-width: 72px;\n    padding: 8px 10px;\n  }\n\n  .cfg-card__thumb {\n    width: 38px;\n    height: 32px;\n  }\n}\n\n/* ── Coming soon overlay ─────────────────────────────────── */\n.cfg-coming-soon {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.4s ease;\n  z-index: 30;\n}\n\n.cfg-coming-soon--visible {\n  opacity: 1;\n}\n\n.cfg-coming-soon__title {\n  font-family: 'Montserrat', system-ui, sans-serif;\n  font-weight: 700;\n  font-size: 36px;\n  letter-spacing: -0.5px;\n  color: #ffffff;\n  margin: 0;\n  text-shadow:\n    1px  1px 0 rgba(0,0,0,0.4),\n   -1px -1px 0 rgba(0,0,0,0.4),\n    0 0 20px rgba(0,0,0,0.3);\n}\n\n.cfg-coming-soon__sub {\n  font-family: 'Montserrat', system-ui, sans-serif;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1.7;\n  text-align: center;\n  color: rgba(200, 206, 222, 0.75);\n  margin: 0;\n  text-shadow: 0 1px 6px rgba(0,0,0,0.4);\n}\n\n/* ── Hotspot info panel ───────────────────────────────────── */\n.cfg-hotspot-info {\n  position: absolute;\n  left: 36px;\n  top: 50%;\n  transform: translateY(-50%) translateX(-18px);\n  width: 260px;\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.5s ease, transform 0.5s ease;\n  z-index: 20;\n  user-select: none;\n  mix-blend-mode: difference;\n}\n\n.cfg-hotspot-info--visible {\n  opacity: 1;\n  transform: translateY(-50%) translateX(0);\n}\n\n.cfg-hotspot-info__title {\n  font-family: 'Montserrat', system-ui, sans-serif;\n  font-weight: 700;\n  font-size: 28px;\n  line-height: 1.1;\n  letter-spacing: -0.5px;\n  color: #ffffff;\n  margin: 0 0 14px 0;\n}\n\n.cfg-hotspot-info__body {\n  font-family: 'Montserrat', system-ui, sans-serif;\n  font-weight: 400;\n  font-size: 13px;\n  line-height: 1.65;\n  color: #c8cede;\n  margin: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
